export function useSchemaOrgData(product: SingleProduct) {
  const route = useRoute()
  const { url: root } = useSiteConfig()

  // TODO: Use more built-ins from nuxt-schema-org
  return useSchemaOrg([
    {
      '@context': 'https://schema.org',
      '@graph': product.variants.map((variant) => ({
        '@type': [
          'Product',
          variant.productForm === 'PAPER' ? 'Book' : 'LearningResource',
        ].filter(truthy),
        'author': variant.authors?.split(', '),
        'name': variant.title,
        'image': variant.cover?.url ?? product.cover?.url,
        'description': variant.description,
        'sku': variant.sku,
        'isbn': variant.isbn,
        'gtin13': variant.isbn,
        'copyrightYear': variant.copyrightYear,
        'datePublished': variant.release?.toISOString().slice(0, 10), // Simplest way to get YYYY-MM-DD
        'inLanguage': variant.languages,
        'numberOfPages': variant.pages ? Number(variant.pages) : undefined,
        'offers': {
          '@type': 'Offer',
          'availability': 'https://schema.org/InStock',
          'itemCondition': 'https://schema.org/NewCondition',
          'priceCurrency': 'NOK',
          'url': variant.isPurchasable
            ? `${root}${route.path}#${variant.isbn}`
            : `https://www.norli.no/${variant.isbn}`,
          // TODO: Investigate if this should be based on calculated prices
          'price': (
            variant.prices.discount ??
            variant.prices.incVat ??
            variant.prices.default
          )?.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
          'seller': {
            '@type': 'Organization',
            'name': variant.isPurchasable ? 'Aschehoug' : 'Norli',
          },
        },
        'educationalLevel': variant.grades
          ?.map((grade) => {
            if (!grade.startsWith('aarstrinn') && !grade.startsWith('vg')) {
              // Other grade codes are not directly supported by UDIR. TODO: Perform mapping for codes that have suitable equivalents with UDIR.
              return null
            }

            return {
              '@type': 'DefinedTerm',
              'name': grade,
              'inDefinedTermSet': {
                '@type': 'DefinedTermSet',
                'url': 'https://data.udir.no/kl06/aarstrinn',
              },
            }
          })
          .filter(truthy),
      })),
    },
  ])
}
